import { sendWebsocketMessage } from '../../../../../App';

/**
 * sends a message to the b.e to send an alert to the F.E
 */
export function testAlert() {
  const msg = {
    messageType: 'testAlert',
  };
  sendWebsocketMessage(msg);
}
